<div class="container">
  <ng-container></ng-container>
</div>
